import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UserAccountActions = createActionGroup({
  source: 'User Account Page',
  events: {
    'Configure MFA': emptyProps(),

    'Disable MFA': emptyProps(),
    'Disable MFA Success': props<{ hasRemainingMfaEnabled: boolean }>(),
    'Disable MFA Failure': props<{ error: unknown }>(),

    'Enable MFA': emptyProps(),
    'Enable MFA Success': emptyProps(),
    'Enable MFA Failure': props<{ error: unknown }>(),

    'Open Change Password Dialog': emptyProps(),
    'Submit Update Password': props<{ oldPassword: string; newPassword: string }>(),
    'Update Password Success': emptyProps(),
    'Update Password Error': props<{ error: unknown }>(),
    'Cancel Update Password': emptyProps(),

    'Create New Company': emptyProps(),
  },
});
